import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { KeycloakAuthGuard } from "./core/guards/auth.guard";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "/home",
  },
  {
    path: "home",
    loadChildren: () =>
      import("src/app/modules/home/home.module").then((m) => m.HomeModule),
    data: { breadcrumb: "Inicio" },
    canActivate: [KeycloakAuthGuard],
  },
  {
    path: "i",
    loadChildren: () =>
      import("src/app/modules/wedding/wedding.module").then(
        (m) => m.WeddingModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
